import { Filter, ListResult } from 'app/models';
import { TakeDown, TakeDownData } from 'app/models/TakeDown';
import Axios from '.';

/*
 ** Submit Take Down Report (https://menspace-app-dev.appicidea.com/doc/v2#get-/v1/takeDown/-takeDownId-)
 */

export const createTakeDown = async (params: TakeDown) => {
  const { data } = await Axios.post<any>(`/takeDown`, params);
  return data;
};

/*
 ** Submit Take Down Report (https://menspace-app-dev.appicidea.com/doc/v2#get-/v1/takeDown/-takeDownId-)
 */

export interface GetTakeDownListParams extends Filter {}

export const getTakeDownList = async (params: GetTakeDownListParams) => {
  const { data } = await Axios.get<ListResult<TakeDownData>>('/takeDown', {
    params,
  });
  return data;
};

/*
 ** Get one TakeDown by takeDownId (https://menspace-app-dev.appicidea.com/doc/v2#get-/v1/takeDown/-takeDownId-)
 */

export const getOneTakeDown = async (takeDownId: string | number) => {
  const { data } = await Axios.get<TakeDownData>(`/takeDown/${takeDownId}`);
  return data;
};
